import { P2GCardContainer, P2GGrid } from '@parcel2go/core-ui';
import { Skeleton } from '@mui/material';

export default function SkeletonLoader({ count }: { count: number }) {
  return (
    <P2GGrid container direction="column" spacing={2}>
      {Array.from({ length: count }).map((_, index) => (
        <P2GGrid item key={index}>
          <P2GCardContainer style={{ maxHeight: 'none' }}>
            <P2GGrid container spacing={2}>
              <P2GGrid item>
                <Skeleton variant="circular" width={40} height={40} />
              </P2GGrid>
              <P2GGrid item flexGrow={1}>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton />
              </P2GGrid>
              <P2GGrid item>
                <Skeleton variant="rounded" width={150} height={60} />
              </P2GGrid>
              <P2GGrid item>
                <Skeleton variant="rounded" width={150} height={60} />
              </P2GGrid>
            </P2GGrid>
          </P2GCardContainer>
        </P2GGrid>
      ))}
    </P2GGrid>
  );
}
